import isEmpty from 'lodash/isEmpty';

export default class ResultsInterfaceBuffer {
  constructor() {
    this.info = null;
    this.custom = null;
  }

  put(type, value) {
    if (this.has(type)) Logger.warn(`Duplicated response from ${type} channel received. Consider this message as possible regression`);

    this[type] = value;
  }

  get(type) {
    return this[type];
  }

  has(type) {
    return !isEmpty(this[type]);
  }

  isFull() {
    return this.has('info') && this.has('custom');
  }

  clear() {
    this.info = null;
    this.custom = null;
  }
}
